var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Observer } from 'mobx-react-lite';
import moment from 'moment';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { uniqById } from '../../utils/ramdaEquivalents.utils';
import BaseCalendarEvent from './BaseCalendarEvent';
import './BaseCalendarEventList.scss';
function BaseCalendarEventList(props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get events() {
            return uniqById(p.events);
        },
        get eventsOrderedByTime() {
            var result = __spreadArray([], s.events, true).sort(function (a, b) {
                if (!a.startTime)
                    return -1;
                if (!b.startTime)
                    return 1;
                var at = moment(a.startTime);
                var bt = moment(b.startTime);
                // @ts-ignore
                var diff = at.diff(bt);
                return diff;
            });
            return result;
        },
        get Renderer() {
            return p.eventRenderer || BaseCalendarEvent;
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('BaseCalendarEventList', p.className) }, s.eventsOrderedByTime.map(function (e, i) { return React.createElement(s.Renderer, { key: e.id || e.startTime + '_' + i, calendarEvent: e, timezoneMode: p.timezoneMode, eventTypeGroups: p.eventTypeGroups, shouldShowEventEndTime: p.shouldShowEventEndTime, defaultOnEventClick: p.onEventClick }); }))); } });
}
export default BaseCalendarEventList;
